import { BASE_URL } from "../../util/Constants";
import axios from "axios";

export async function getDepartamentos(setDepartamentos) {
    const url = BASE_URL + "departamentos";
  
    await axios
      .request({
        method: "GET",
        url: url,
      })
      .then((response) => setDepartamentos(response.data));
  }